module.exports = __webpack_public_path__ + "static/media/logo_200x200.e3ee996c.png";